import * as React from 'react';
import { SVGProps } from 'react';

const IconFileArchiveSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1h5v2h1v1H7v1h1v1H7v1h1v1H7v1h1v4H5V9h1V7H5V6h1V5H5V4h1V2H3v12h10V2H9V1h5v14H2V1Zm5 9H6v2h1v-2Z"
    />
  </svg>
);
export default IconFileArchiveSizeS;
